import { combineReducers } from "redux";

import { reducer as postingDetail } from "./postingDetail/postingDetailSlice";
import { postingListReducer as postings } from "./postingList/postingListActions";

export default combineReducers({
  postings,
  postingDetail,
});
